import React, { useState } from 'react'
import {
  DashboardOutlined,
  BarChartOutlined,
  LogoutOutlined,
  UserOutlined,
  DollarOutlined,
  CrownOutlined,
  FileTextOutlined,
  ScheduleOutlined,
  CameraOutlined,
  ClockCircleOutlined,
  FaAddressCard,
  IdcardOutlined,
  ContactsOutlined,
  CreditCardOutlined,
} from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { Drawer, Grid } from 'antd'
import LogoutModal from './Logout'

const { useBreakpoint } = Grid

const NAV_CONFIG = [
  // {
  //   section: 'MAIN',
  //   items: [
  //     { key: 'ad-dashboard', label: 'Dashboard', icon: <DashboardOutlined /> },
  //   ],
  // },
  {
    section: 'MASTERS',
    items: [
      { key: 'm-slot', label: 'Slot Master', icon: <ClockCircleOutlined /> },
      {
        key: 'm-terms_condition',
        label: 'Terms & Condition Master',
        icon: <FileTextOutlined />,
      },
      {
        key: 'm-life_time_member',
        label: 'Lifetime Membership Master',
        icon: <CrownOutlined />,
      },
      { key: 'm-fee', label: 'Fee Master', icon: <DollarOutlined /> },
      { key: 'm-employee', label: 'Employee Master', icon: <UserOutlined /> },
    ],
  },
  {
    section: 'TRANSACTION',
    items: [
      {
        key: 't-ticket_booking',
        label: 'Ticket Booking',
        icon: <ContactsOutlined />,
      },
      {
        key: 't-fee_allocation',
        label: 'Fee Allocation',
        icon: <ScheduleOutlined />,
      },
      {
        key: 't-photo_update',
        label: 'Photo Update',
        icon: <CameraOutlined />,
      },
      
      {
        key: 't-card_printing',
        label: 'Card Printing',
        icon: <IdcardOutlined />,
      },
      {
        key: 't-today_off_book',
        label: "Today's Offline Booking",
        icon: <IdcardOutlined />,
      },
      {
        key: 't-today_on_book',
        label: "Today's Online Booking",
        icon: <IdcardOutlined />,
      },
      {
        key: 't-fee_collection',
        label: 'Fee Collection',
        icon: <CreditCardOutlined />,
      },
    ],
  },
  {
    section: 'Reports',
    items: [{ key: 'reports', label: 'Reports', icon: <BarChartOutlined /> }],
  },
]

export default function AdminSidebar({ activePage, isOpen, onClose }) {
  const navigate = useNavigate()
  const screens = useBreakpoint()
  const isMobile = !screens.lg

  const [logoutOpen, setLogoutOpen] = useState(false)

  const [openSection, setOpenSection] = useState('MAIN') // default open

  const toggleSection = (section) => {
    setOpenSection((prev) => (prev === section ? null : section))
  }

  const confirmLogout = () => {
    sessionStorage.clear()
    navigate('/')
  }

  const SidebarContent = () => (
    <>
      {/* HEADER */}
      <div className="sidebar-brand">
        <h5 className="text-white">
          <UserOutlined /> Admin Portal
        </h5>
      </div>

      {/* NAVIGATION */}
      <nav className="sidebar-nav">
        <button
          className={`nav-item ${
            activePage === 'ad-dashboard' ? 'active' : ''
          }`}
          onClick={() => {
            navigate('/admin/ad-dashboard')
            onClose()
          }}
        >
          <span style={{ fontSize: 16 }}>
            <DashboardOutlined />
          </span>
          <span style={{ flex: 1 }}>Dashboard</span>
        </button>

        {NAV_CONFIG.map((section) => (
          <div key={section.section}>
            {/* SECTION HEADER */}
            <div
              className="nav-section-label clickable"
              onClick={() => toggleSection(section.section)}
            >
              <span>{section.section}</span>
              <span>{openSection === section.section ? '−' : '+'}</span>
            </div>

            {/* ITEMS */}
            {openSection === section.section &&
              section.items.map((item) => (
                <button
                  key={item.key}
                  className={`nav-item ${
                    activePage === item.key ? 'active' : ''
                  }`}
                  style={{ paddingLeft: 30 }}
                  onClick={() => {
                    navigate(`/admin/${item.key}`)
                    onClose()
                  }}
                >
                  <span style={{ fontSize: 16 }}>{item.icon}</span>
                  <span style={{ flex: 1 }}>{item.label}</span>
                </button>
              ))}
          </div>
        ))}
      </nav>

      {/* FOOTER */}
      {/* <div className="sidebar-footer">
        <button
          className="nav-item nav-logout"
          onClick={() => setLogoutOpen(true)}
        >
          <LogoutOutlined />
          <span>Logout</span>
        </button>
      </div> */}
    </>
  )

  return (
    <>
      {isMobile ? (
        <Drawer
          placement="left"
          open={isOpen}
          onClose={onClose}
          width="100%"
          bodyStyle={{ padding: 0 }}
        >
          <SidebarContent />
        </Drawer>
      ) : (
        <>
          <div
            className={`sidebar-overlay ${isOpen ? 'show' : ''}`}
            onClick={onClose}
          />

          <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
            <SidebarContent />
          </aside>
        </>
      )}

      <LogoutModal
        open={logoutOpen}
        onCancel={() => setLogoutOpen(false)}
        onConfirm={confirmLogout}
      />
    </>
  )
}
